import { render, staticRenderFns } from "./salesData.vue?vue&type=template&id=0879dff4&scoped=true"
import script from "./salesData?vue&type=script&lang=js&external"
export * from "./salesData?vue&type=script&lang=js&external"
import style0 from "./salesData.vue?vue&type=style&index=0&id=0879dff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0879dff4",
  null
  
)

export default component.exports